<template>
  <div>
    <div v-if="addressTokens && addressTokens.length > 0">
      <b-table :data="addressTokens" class="table"
	    v-bind:mobileCards="false"
      >
        <template slot-scope="props">
          <b-table-column field="name" label="Name">
            <router-link
              class="router-link"
              :to="{ name: 'token', params: {token: props.row.contractAddress}}"
            >{{ props.row.tokenName }}</router-link>
          </b-table-column>

          <b-table-column field="symbol" label="Symbol">{{ props.row.tokenSymbol }}</b-table-column>

          <b-table-column field="contract" label="Contract">
            <router-link
              class="router-link short-addr contract-addr"
              :to="{ name: 'address', params: {address: props.row.contractAddress}}"
            >
              {{ props.row.contractAddress }}
            </router-link>
          </b-table-column>

          <b-table-column field="balance" label="Balance">{{ props.row.balance }}</b-table-column>
        </template>
      </b-table>
    </div>
    <Empty v-else/>
    <el-pagination
      small
      background
      @current-page="current_page"
      @current-change="shift"
      @prev-click="shift(current_page-1)"
      @next-click="shift(current_page+1)"
      layout="prev, pager, next"
      :current_page.sync="current_page"
      :pager-count="5"
      :page-size="pageSize"
      :total="totalAddressTokens"
    ></el-pagination>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Empty from '../reusables/empty.vue';

export default {
  name: 'TokenBalances',
  props: ['address'],
  components: {
    Empty,
  },
  data() {
    return {
      current_page: 1,
      pageSize: 10,
    };
  },
  computed: {
    ...mapGetters(['addressTokens', 'totalAddressTokens']),
  },
  watch: {
    '$route.params.address': function () {
      this.shift(1);
    },
  },
  methods: {
    shift(page) {
      this.$store.dispatch('fetchAddressTokens', {
        address: this.address,
        limit: this.pageSize,
        page,
      });
      this.current_page = page;
    },
  },
  created() {
    this.shift(1);
  },
};
</script>
